import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiClient } from "../../lib/api-client";

export function MagicLinkPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      return;
    }
    apiClient
      .get(`/consumer/auth/magic-link/verify?token=${encodeURIComponent(token)}`)
      .then(() => {
        setStatus("success");
        setTimeout(() => navigate("/minha-biblioteca"), 1500);
      })
      .catch(() => setStatus("error"));
  }, [searchParams, navigate]);

  if (status === "loading") return <p>Validando seu link…</p>;
  if (status === "error") return <p role="alert">Link inválido ou expirado. Solicite um novo em Conta.</p>;
  return <p role="status">Login realizado! Redirecionando para sua biblioteca…</p>;
}
